import React, { useMemo } from 'react';

const PlayerChip = ({ player, color }) => {
  const name = player.person?.fullName || '--';
  const lastName = name.split(' ').slice(1).join(' ') || name;
  const pos = player.position?.abbreviation || '--';
  const num = player.jerseyNumber;

  return (
    <div className="flex items-center gap-2 border border-[rgba(101,141,113,0.4)] p-2 bg-[rgba(0,0,0,0.1)]">
      <div className="w-6 h-6 rounded-full flex items-center justify-center shrink-0 text-[9px] font-black text-white"
        style={{ backgroundColor: color + '33', border: `1px solid ${color}` }}>
        {num || pos[0]}
      </div>
      <div className="min-w-0">
        <p className="text-[10px] font-black uppercase tracking-wide text-white truncate">{lastName}</p>
        <p className="text-[8px] text-[#658d71] font-bold uppercase tracking-widest">{pos}</p>
      </div>
    </div>
  );
};

const KeyPlayersToWatch = ({ awayRoster, homeRoster, awayAbbr, homeAbbr }) => {
  const awayPlayers = useMemo(() => (awayRoster?.roster || []).slice(0, 5), [awayRoster]);
  const homePlayers = useMemo(() => (homeRoster?.roster || []).slice(0, 5), [homeRoster]);

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.08)]">
      <div className="px-3 py-2 border-b border-[#658d71] bg-[rgba(0,0,0,0.1)]">
        <span className="text-xs font-black uppercase tracking-widest text-[#d8ceb3]">Key Players to Watch</span>
        <p className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest mt-0.5">Active roster highlights</p>
      </div>
      <div className="p-3 grid grid-cols-2 gap-3">
        <div>
          <p className="text-[9px] font-black uppercase tracking-widest text-[#a9c9b1] mb-2">{awayAbbr}</p>
          <div className="flex flex-col gap-1.5">
            {awayPlayers.map((p, i) => <PlayerChip key={i} player={p} color="#a9c9b1" />)}
          </div>
        </div>
        <div>
          <p className="text-[9px] font-black uppercase tracking-widest text-[#c4333e] mb-2">{homeAbbr}</p>
          <div className="flex flex-col gap-1.5">
            {homePlayers.map((p, i) => <PlayerChip key={i} player={p} color="#c4333e" />)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KeyPlayersToWatch;